/**
 * @owner @Appboy/clx
 */
import type { PermissionContextPayload } from "@navigationRouting/types";

/**
 * Workspace Alerts pages are for anyone who can view Canvases, behind the product alerts and workspace alerts
 * flippers. Only workspace admins can turn alerts on or off; everyone else sees them read-only.
 */
export const getWorkspaceAlertsNavigationAllowed = ({ featureOn, hasPermission }: PermissionContextPayload) => {
  return (
    featureOn("product_alerts") &&
    featureOn("canvas_workspace_alerts_fe") &&
    hasPermission("appGroup", { permission: "viewCanvases" })
  );
};
